import eventQueries from '@apis/queries/eventQueries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

import useEvent from './useEvent';

function useAttendanceEvent(eventId: string) {
    const event = useEvent(eventId);
    const { user } = useUser();
    const { data: progress } = useQuery({
        ...eventQueries.attendanceProgress(eventId),
        enabled: event?.eventType === 'ATTENDANCE' && !!user,
    });
    const { data: policy } = useQuery(eventQueries.attendancePolicy(eventId));
    return {
        progress,
        policy,
    };
}

export default useAttendanceEvent;
